<div class="detail-page-card">
    <div class="detail-page-card-body padded form-group-styling cerrix-control-sm">
        <div class="btn-toolbar">
            @if (!disabled) {
                <button class="btn btn-raised red pull-right" (click)="deleteEntity()">
                    <i class="fas fa-minus-circle"></i>
                    <span>{{ 'datamanagement.dataStructures.deleteThirdPartyBtn' | transloco }}</span>
                </button>
            }
        </div>
        @if (entityModel && entityForm) {
            <form [formGroup]="entityForm">
                <div class="row">
                    <div class="col-4 name">
                        <div class="form-group">
                            {{ entityModel.name }}
                        </div>
                    </div>
                    <div class="col-8">
                        <div class="form-group">
                            <ng-select
                                name="roleSelect"
                                [items]="entityRoles"
                                formControlName="role"
                                bindLabel="name"
                                bindValue="id"
                                [closeOnSelect]="true"
                                [multiple]="false"
                                [clearable]="false"
                                placeholder="{{ 'datamanagement.dataStructures.roleSelectPlaceholder' | transloco }}"
                            >
                            </ng-select>
                        </div>
                    </div>
                </div>
                @if (entityRoleSelected) {
                    <div class="row">
                        <div class="col-4">
                            <div class="form-group">
                                @if (showSubprocessor) {
                                    <cerrix-checkbox
                                        [label]="'datamanagement.dataStructures.subProcessorLabel' | transloco"
                                        fontsize="0.9em"
                                        formControlName="subProcessor"
                                    >
                                    </cerrix-checkbox>
                                }
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="form-group">
                                <label>{{ 'datamanagement.dataStructures.systemsRequiredLabel' | transloco }}</label>
                                <ng-select
                                    name="SystemsRequired"
                                    [items]="systemsRequired"
                                    formControlName="systemsRequired"
                                    bindLabel="name"
                                    bindValue="id"
                                    [closeOnSelect]="true"
                                    [multiple]="false"
                                    placeholder="{{ 'datamanagement.dataStructures.systemsRequiredPlaceholder' | transloco }}"
                                >
                                </ng-select>
                            </div>
                        </div>
                    </div>
                }
                <hr />

                @if (systemsRequiredSelected) {
                    <div>
                        @if (!disabled) {
                            <div class="btn-toolbar">
                                @if (showAddSystems) {
                                    @if (systemOptions.length > 0) {
                                        <button
                                            class="btn btn-raised pull-right"
                                            (click)="showAddSystemsDialog()"
                                        >
                                            <i class="fas fa-plus-circle"></i>
                                            <span>{{ 'datamanagement.dataStructures.addSystemsBtn' | transloco }}</span>
                                        </button>
                                    } @else {
                                        <span>{{ 'datamanagement.dataStructures.thirdPartyMissingSystems' | transloco }}</span>
                                    }
                                }
                            </div>
                        }

                        @for (systemModel of entityModel.systems; track systemModel) {
                            <div class="system-detail">
                                <system-detail
                                    [systemModel]="systemModel"
                                    [standingData]="standingData"
                                    (systemDeleted)="deleteSystem($event)"
                                    [disabled]="disabled"
                                >
                                </system-detail>
                            </div>
                        }
                    </div>
                }
            </form>
        }
    </div>
</div>
